export enum ApprovalStatusEnum {
  WaitingApproval = 'WaitingApproval',
  Approved = 'Approved',
  DeclinedApproval = 'DeclinedApproval',
}
